<template>
  <div class="mHomeView" id="mHome">
    <mHomeText></mHomeText>
  </div>
</template>

<script>
import mHomeText from "@/components/MobileComponents/mHomeText.vue";
export default {
  name: "mHomeView",
  data: () => ({}),
  components: {
    mHomeText,
  },
  computed: {},
  methods: {},
};
</script>

<style></style>
